export default function focusInput(input) {
  if (input) input.focus();
}
